import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import FormSectionHeader from "./FormSectionHeader";
import useAuthStore from "../../Zustand/Store/useAuthStore";
import useEmployeeDataStore from "../../Zustand/Store/useEmployeeDataStore";

const SingleFormLayout = ({ sections, mode }) => {
  const [employeeId, setEmployeeId] = useState("");
  const { getDropdowndata } = useEmployeeDataStore();
  const { userData } = useAuthStore();
  const org = userData?.organization;

  useEffect(() => {
    if (org?.organization_id) {
      getDropdowndata(org.organization_id);
    }
  }, [org?.organization_id]);

  return (
    <Box component="form" noValidate>
      {sections.map((section) => {
        const Component = section.customComponent;
        return (
          <div key={section.id} className="ems-fm-section">
            <FormSectionHeader
              title={section.title}
              subtitle={section.subtitle}
            />
            {Component && (
              <Component
                mode={mode}
                singleForm
                employeeId={employeeId}
                setEmployeeId={setEmployeeId}
                organizationId={org?.organization_id}
              />
            )}
          </div>
        );
      })}
    </Box>
  );
};

export default SingleFormLayout;
